import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ClickOutside from 'react-onclickoutside'
import {Wrapper, MenuIcon} from './components/Styled'

import Symbol from 'core/components/Symbol'
import classNames from 'classnames'

class SiteMenuMobile extends Component {
  static defaultProps = {
    isHidden: true,
    title: '',
    menus: [{}],
    closeIcon: ''
  }

  static propTypes = {
    closeIcon: PropTypes.string,
    isHidden: PropTypes.bool,
    menus: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      isHidden: this.props.isHidden,
      tabOpen: null,
      subTabOpen: null
    }
  }

  handleMenu = () => {
    this.setState({
      isHidden: !this.state.isHidden
    })
  }

  handleOpenCloseTab (tabOpen) {
    this.setState({
      tabOpen: this.state.tabOpen !== tabOpen ? tabOpen : null,
      subTabOpen: null
    })
  }

  handleOpenCloseSubTab (subTabOpen) {
    this.setState({subTabOpen: this.state.subTabOpen !== subTabOpen ? subTabOpen : null})
  }

  handleClickOutside () {
    this.setState({isHidden: true})
  }

  renderMenuIcon () {
    return (
      <MenuIcon onClick={this.handleMenu}>
        <span>{this.props.title}</span>
        {
          this.state.isHidden
            ? <Symbol className='icon icon-menu' name='icon-menu' />
            : <Symbol className='icon icon-close' name={this.props.closeIcon} />
        }
      </MenuIcon>
    )
  }

  renderMenuAccordion (menu) {
    let key = this.getKey(menu.title)
    return (
      <li key={key} className={classNames(
        'accordion accordion-menu__list-item',
        {'open': this.state.tabOpen === key, 'special': menu.type === 'special'}
      )}>
        <span className='accordion-menu__list-control' onClick={() => this.handleOpenCloseTab(key)}>{menu.title} <span>{this.state.tabOpen === key ? '–' : '+'}</span></span>
        <ul className={classNames(
          'accordion-menu__sub-list',
          {'open': this.state.tabOpen === key}
        )}>
          {this.renderAccordion(menu.menu)}
        </ul>
      </li>
    )
  }

  renderAccordion (menu) {
    return (
      <li className='accordion accordion-menu__list-item'>
        {
          menu.map((menuItems, key) => {
            return menuItems.hasOwnProperty('title')
              ? this.renderSubAccordion(menuItems)
              : <ul key={key} className='pl0 pr0'>{this.renderMenuLinks(menuItems)}</ul>
          })
        }
      </li>
    )
  }

  renderSubAccordion (menuItems) {
    let key = this.getKey(menuItems.title)
    return (
      <ul key={key}>
        <li className={classNames(
          'accordion accordion-menu__list-item',
          {'open': this.state.subTabOpen === key}
        )}>
          <span className='accordion-menu__list-control accordion-menu__list-control--small accordion-menu__sub-link' onClick={() => this.handleOpenCloseSubTab(key)}>
            {menuItems.title}
          </span>
          <ul className={classNames(
            'accordion-menu__sub-list pl0 pr0',
            {'open': this.state.subTabOpen === key}
          )}>
            { this.renderMenuLinks(menuItems) }
          </ul>
        </li>
      </ul>
    )
  }

  renderMenuLinks (menuItems) {
    let key = this.getKey(menuItems.title || `menu-link-${Math.random()}`)
    return (
      <li key={key} className='accordion accordion-menu__list-item'>
        {
          menuItems.items.map(menuItem => {
            return this.renderLink(menuItem)
          })
        }
      </li>
    )
  }

  getKey (title) {
    return title.replace(/\s+/g, '-').toLowerCase()
  }

  renderLink (item) {
    let key = this.getKey(item.title)
    return (
      <a key={key} className={`accordion-menu__link accordion-menu__text-link ${item.icon && 'accordion-menu__link-with-image'}`} href={item.url}>
        <span>{item.hasOwnProperty('icon') && item.icon}</span>&nbsp;
        {item.title}
      </a>
    )
  }

  renderAccordionFooter () {
    return (
      <div>
        <div className='accordionFooterItem'>
          <Symbol className='icon' height='15' name='icon-akc-home' width='15' />
          <a href='https://www.akc.org'>AKC.org</a>
        </div>
        <div className='accordionFooterItem'>
          <Symbol className='icon' height='15' name='icon-akc-cart' width='15' />
          <a href='https://shop.akc.org'>Shop</a>
        </div>
      </div>
    )
  }

  render () {
    return (
      <Wrapper>

        {this.renderMenuIcon()}

        <div className='slim-header__dropdowns'>
          <div className={classNames(
            'site-menu',
            {'is-open': !this.state.isHidden}
          )} style={this.state.isHidden ? {visibility: 'hidden'} : null}>

            <nav className='accordion-menu'>
              <ul className='accordion accordion-menu__list pl0 pr0'>
                {
                  this.props.menus.map(menu => {
                    return this.renderMenuAccordion(menu)
                  })
                }
              </ul>
            </nav>

            {this.renderAccordionFooter()}

          </div>
        </div>
      </Wrapper>
    )
  }
}

export default ClickOutside(SiteMenuMobile)
